import { styled, keyframes } from '@mui/material/styles';
import { IconButton } from '@mui/material';

export const rotateCenter = keyframes`
    0% {
        -webkit-transform: rotate(0);
                transform: rotate(0);
    }
    100% {
        -webkit-transform: rotate(-360deg);
                transform: rotate(-360deg);
    }
`;

export const AsyncIconButton = styled(IconButton)(() => ({
    color: '#1976d2',
    fontSize: '12px',
    marginLeft: '8px',
    '&.rotate': {
        animation: `${rotateCenter} infinite linear 1s`,
    },
}));